// extracted by mini-css-extract-plugin
module.exports = {"repeatLots":"4","natural-stone":"natural_stone_style_natural-stone__2v7uy","natural-stone-content":"natural_stone_style_natural-stone-content__18Bpu"};